import React from 'react';
import { Link } from 'gatsby';

import Form from 'react-bootstrap/Form';

import { ApiContext } from '../../context/apicontext';
import { SessionContext } from '../../context/sessioncontext';
import { slugifyShow, formatLocaleTime } from '../../utils/common';

import './showschedule.css';

const shows = require(`../../../static/data/shows.json`);

const ShowSchedule = (props) => {
	const Api = React.useContext(ApiContext);
	const userSession = React.useContext(SessionContext);
	const { showTitle, seasonIndex } = props;

	const [scores, setScores] = React.useState(undefined);

	const show = shows.find(show => show.title === showTitle);
	const season = show.seasons[seasonIndex-1];

	React.useEffect(() => {
		const apioptions = {};
		if (userSession.user) {
			apioptions.headers = {
				'Content-Type': 'application/json',
				'Authorization': `Bearer ${userSession.session}`
			};
		}
		Api.fetch(`score/${season.id}`, apioptions, (result) => {
			setScores(result.response === 1 ? result.scores : []);
		});
	}, [Api, userSession, season, setScores]);

	return (
		<ShowSeason show={show} season={season} scores={scores} />
	);
};

const ShowSeason = (props) => {
	const { show, season, scores } = props;

	const dtNow = new Date();
	const LinkTitle = (episode) => {
		const dtAired = new Date(episode.airdate);
		if (dtAired > dtNow) return <>{episode.title}</>;
		return (
			<Link to={slugifyShow(show.title, season.index, episode.index)}>
				{episode.title}
			</Link>
		);
	};

	const LinkRating = (episode) => {
		if (!episode.airdate) return (<>TBA</>);
		const dtAired = new Date(episode.airdate);
		const dtEnded = new Date(dtAired.getTime()+(60*60*1000*1));
		if (dtEnded > dtNow) return <>{formatLocaleTime(episode.airdate, false)}</>;
		if (!scores) return (<></>);
		const score = scores.find(s => s.id === episode.id);
		if (!score) return <>{formatLocaleTime(episode.airdate, false)}</>;
		return <EpisodeScore score={score} />;
	};

	return (
		<Form>
			<ol>
				{season.episodes.map(episode =>
					<li key={episode.id} className='episodeGrid'>
						<span className='title'>
							{LinkTitle(episode)}
						</span>
						<span>
							{LinkRating(episode)}
						</span>
					</li>
				)}
			</ol>
		</Form>
	);
};

const EpisodeScore = (props) => {
	const userSession = React.useContext(SessionContext);

	const [score, setScore] = React.useState(props.score);
	const [canVote, setCanVote] = React.useState(false);
	const [showForm, setShowForm] = React.useState(false);

	React.useEffect(() => {
		setScore(props.score);
	}, [props.score, setScore]);

	React.useEffect(() => {
		setCanVote(!!userSession.user);
	}, [userSession, setCanVote]);

	React.useEffect(() => {
		setShowForm(canVote && score.last_vote === 0);
	}, [canVote, score, setShowForm]);

	return (
		<React.Fragment>
			{showForm && <EpisodeScoreForm score={score} setScore={setScore} />}
			{!showForm && !canVote && <>{score.avg_rating.toFixed(2)}</>}
			{!showForm && canVote &&
				<span role='presentation' style={{ cursor: 'pointer' }}
					onClick={() => setShowForm(true)}
				>
					{score.avg_rating.toFixed(2)}
				</span>
			}
		</React.Fragment>
	);
};

const EpisodeScoreForm = (props) => {
	const Api = React.useContext(ApiContext);
	const userSession = React.useContext(SessionContext);
	const { score, setScore } = props;

	const handleSelectChange = (vote) => {
		if (vote === '') return;
		const headers = {
			'Content-Type': 'application/json',
			'Authorization': `Bearer ${userSession.session}`
		};
		const body = { vote: parseFloat(vote) };
		Api.fetch(`score/${score.id}`,
			{ method: 'put', headers, body: JSON.stringify(body) },
			(result) => {
				if (result.response === 1) {
					const newScore = {...result.score, last_vote: parseFloat(vote)};
					setScore({...newScore});
				}
			}
		);
	};

	const options = [{ value: '', text: 'Rate' }];
	for (let i = 10; i > 0; i--) {
		options.push({ value: i, text: i });
	}

	return (
		<Form.Select
			size='sm'
			onChange={({ target }) => handleSelectChange(target.value)}
			value={score.last_vote}
		>
			{options.map(s =>
				<option key={s.value} value={s.value}>{s.text}</option>
			)}
		</Form.Select>
	);
};

export default ShowSchedule;
